import { Popover } from '@lightspeed/design-system-react'
import React from 'react'
import { useT } from '@transifex/react'
import classNames from 'classnames'
import { MoreActionsItemName } from '../useMoreSaleActions'
import { useAppSelector } from '../../../state/hooks'
import { selectIsParkedSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { useMoreActionsPopover } from './useMoreActionsPopover'

type Props = {
  closePopover: () => void
  shouldDisableActions: boolean
  clickHandler: (data: MoreActionsItemName) => void
}

/**
 * Shared function to determine the css class name for each menu item
 */
const getClassName = (shouldDisable: boolean) =>
  classNames('vd-popover-list-item', {
    'wr-more-actions-disabled': shouldDisable,
  })

export const MoreActionsPopover = (props: Props) => {
  const { closePopover, shouldDisableActions, clickHandler } = props
  const t = useT()
  const {
    shouldDisableQuote,
    shouldDisableService,
    shouldDisableMarkAsUnfulfilled,
    shouldDisableDiscardSale,
    isServiceOrderEnabled,
    isFulfilmentLifB3Enabled,
  } = useMoreActionsPopover(shouldDisableActions)

  const quoteSale = () => clickHandler('QUOTE')
  const createService = () => clickHandler('SERVICE')
  const discardSale = () => clickHandler('DISCARD')
  const markAsUnfufilled = () => clickHandler('UNFULFILLED')
  const isMarkAllItemsForFulfillmentHidden = useAppSelector(selectIsParkedSale)

  return (
    <Popover onClose={closePopover} className="wr-more-actions-popover">
      <ul className="vd-popover-list">
        <li>
          <span
            className={getClassName(shouldDisableQuote)}
            data-cy="quote-sale-button"
            onClick={quoteSale}
          >
            {t('Create a quote…', { _context: 'Create quote menu item' })}
          </span>
        </li>
        {isServiceOrderEnabled && (
          <li>
            <span
              className={getClassName(shouldDisableService)}
              onClick={createService}
            >
              {t('Create service…', { _context: 'Create service menu item' })}
            </span>
          </li>
        )}
        {!isMarkAllItemsForFulfillmentHidden && (
          <li>
            <span
              data-testid="mark-as-unfulfilled-button"
              className={getClassName(shouldDisableMarkAsUnfulfilled)}
              data-cy="mark-as-unfulfilled-button"
              onClick={markAsUnfufilled}
            >
              {isFulfilmentLifB3Enabled
                ? t('Mark all items for fulfillment…', {
                    _context: 'Mark as unfulfilled menu item',
                  })
                : t('Mark as unfulfilled…', {
                    _context: 'Mark as unfulfilled menu item',
                  })}
            </span>
          </li>
        )}
        <li>
          <span
            className={getClassName(shouldDisableDiscardSale)}
            data-cy="discard-sale-button"
            onClick={discardSale}
          >
            {t('Discard sale', { _context: 'Discard sale menu item' })}
          </span>
        </li>
      </ul>
    </Popover>
  )
}
